/**axios封装
  * 请求拦截、相应拦截、错误统一处理
  */
import Vue from 'vue';
// import router from '../pages/index/router'
import axios from 'axios';
// import qs from 'qs';
import { store } from '../store';
let Constants = require("./base.default.js");
// vant组件
import { Toast } from "vant";
Vue.use(Toast);

// 创建axios实例
const service = axios.create({
    baseURL: process.env.NODE_ENV === 'development'
        ? '' //开发环境
        : window.location.href.split("/h5")[0],
    timeout: 8000, // 请求的超时时间
    //设置默认请求头，使post请求发送的是formdata格式数据
    headers: {
        "Content-Type": "multipart/form-data"
    },
    withCredentials: true // 允许携带cookie
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const appKey = store.state.appKey;
        // let url = window.location.href
        let url = config.url.substr(0, config.url.indexOf("?"));
        if (url === '/app/live/getApiSign') {
            config.headers.APPKEY = "xinmem3.0";
            // config.headers.Referer = Constants.baseURL;
        } else {
            config.headers.SIGN = appKey;
            config.headers.APPKEY = "xinmem3.0";
        }

        // if(appKey) {
        //     config.headers.SIGN = appKey;
        //     config.headers.APPKEY = "zdg";
        // }
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.error_code, response.data.error_msg) {
                if (response.data.error_code === 1001) {
                    return Promise.resolve(response);
                } else {
                    Toast(response.data.error_msg);
                }
            } else {
                return Promise.resolve(response);
            }
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.data.error_code) {
            const { error_code, error_msg } = error.response.data;
            switch (error_code) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 1:
                    Toast(error_msg);
                    break;
                // // 403 token过期
                // // 登录过期对用户进行提示
                // // 清除本地token和清空vuex中token对象
                // // 跳转登录页面
                // case 403:
                //     this.$message({
                //         message: '登录过期，请重新登录',
                //         duration: 1000,
                //         type: 'warning',
                //         center: true
                //     });
                //     // 清除token
                //     localStorage.removeItem('token');
                //     store.commit('loginSuccess', null);
                //     // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                //     setTimeout(() => {
                //         router.replace({
                //             path: '/login',
                //             query: {
                //                 redirect: router.currentRoute.fullPath
                //             }
                //         });
                //     }, 1000);
                //     break;
                // // 404请求不存在
                // case 404:
                //     this.$message({
                //         message: '页面不存在!',
                //         duration: 1000,
                //         type: 'warning',
                //         center: true
                //     });
                //     break;
                // 其他错误，直接抛出错误提示
                default:
                    Toast(error_msg);
            }
            return Promise.reject(error.response);
        }
    }
);

export async function upload(url, params) {
    return new Promise((resolve, reject) => {
        service.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
  * get方法，对应get请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        service.get(url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export async function post(url, params = null) {
    var formData = new FormData();
    if (params) {
        for (const i in params) {
            formData.append(i, params[i])
        }
    }
    var is_h5 = '?is_h5=' + (getUrlKey("is_h5") ? getUrlKey("is_h5") : '');
    var share = '&share=' + (getUrlKey("share") ? getUrlKey("share") : '');
    var mini = '&mini=' + (getUrlKey("mini") ? getUrlKey("mini") : '');
    var sessionid = getUrlKey("sessionid") ? getUrlKey("sessionid") : getCookie("_wap-zdg-sessionid");
    formData.append('sessionid', sessionid);
    var str = is_h5 + mini + share;
    let { data } = await service.post("/app/live/getApiSign" + str, formData);
    store.dispatch("set_app_key", data.SIGN)
    return new Promise((resolve, reject) => {
        service.post(url + str, formData)
            // service.post(url, qs.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
function getCookie(name) {
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
            return arr[1];
        }
    }
    return "";
}
